import { decode, isFull, isShort, recoverNearest } from 'open-location-code';
import type { LatLng } from '@/core/utils';
import type { ParsedCoordinates } from './types';

/** A full Plus Code like "85GCQ4R6+PP". `compact` is upper case without whitespace. */
export function parseFullPlusCode(compact: string): ParsedCoordinates | null {
  if (!isFull(compact)) return null;
  const a = decode(compact);
  return { lat: a.latitudeCenter, lng: a.longitudeCenter, format: 'plusCode' };
}

/** "Q4R6+PP Salt Lake City, Utah" → { code: 'Q4R6+PP', locality: 'Salt Lake City, Utah' } */
export function parseShortPlusCode(text: string): { code: string; locality: string } | null {
  const words = text.trim().split(/\s+/);
  const i = words.findIndex((w) => isShort(w.replace(/,$/, '').toUpperCase()));
  if (i < 0) return null;
  const code = words[i].replace(/,$/, '').toUpperCase();
  const locality = words
    .filter((_, j) => j !== i)
    .join(' ')
    .replace(/^[,\s]+|[,\s]+$/g, '');
  return { code, locality };
}

/** Recovers a short code relative to a reference location; returns the full code and its centre. */
export function recoverPlusCode(shortCode: string, ref: LatLng) {
  const code = recoverNearest(shortCode, ref.lat, ref.lng);
  const a = decode(code);
  return { code, lat: a.latitudeCenter, lng: a.longitudeCenter };
}
